import { createFileRoute } from '@tanstack/react-router'

import { RevenueCompareSearchSchema } from '@/pages/brevo/revenue/revenue-report-search'

export const Route = createFileRoute('/_layout/brevo/revenue/compare')({
  validateSearch: RevenueCompareSearchSchema,
})
